/* eslint-disable */
import girl1 from '../assets/svg/testimonials/girl1.svg'
import girl2 from '../assets/svg/testimonials/girl2.svg'
import girl3 from '../assets/svg/testimonials/girl3.svg'
import boy1 from '../assets/svg/testimonials/boy1.svg'
import boy2 from '../assets/svg/testimonials/boy2.svg'
import boy3 from '../assets/svg/testimonials/boy3.svg'



export const testimonialsData = [
    {
        id: 1,
        name: 'Casey Feodora',
        title: 'Elementary school student',
        text: "Miss Dinda is very friendly. She always makes the lesson fun to learn. I enjoy studying English with her.",
        image: girl1
    },
    {
        id: 2,
        name: 'Ahmad Aditya',
        title: 'High school student',
        text: "Learning English with Miss Dinda makes me understand materials easily. She is a friendly and kind-hearted teacher. Try to learn English with her and feel the difference!",
        image: boy3
    },
    {
        id: 3,
        name: 'Intan Ramadhani',
        title: 'College student',
        text: "Miss Dinda is different from teachers in general. She is not too strict. I feel like she is not my teacher, but my study partner. She makes me comfortable to share and discuss about anything. So,  I do not only learn about English but also value of life.",
        image: girl2
    },
    {
        id: 4,
        name: 'Lestari Endah',
        title: 'Elementary school teacher',
        text: "I ever tried the translating service and it’s really satisfying. The document is translated well and fast. Also, the price is affordable.",
        image: girl3
    },
    // {
    //     id: 5,
    //     name: 'Coming Soon...',
    //     title: 'Student',
    //     text: 'Ralph Lauren was one of the best things that ever happened to me. My portfolio made that dream happen. I owe you guys.',
    //     image: girl3
    // },
    // {
    //     id: 6,
    //     name: 'Coming Soon...',
    //     title: 'Student',
    //     text: "Be it 'Rocks' or 'Bones', you need a website to display it. This is it. Great work guys !",
    //     image: boy3
    // }
]

